export default "__VITE_ASSET__Bl4m8QV2__"